<script lang="ts" setup>
import RModal from '~/components/organs/Modal.vue'

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    name-modal="supportModal"
    ref="refModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="supportModalLabel"
      >
        Поддержка
      </h5>
    </template>
    <template #body>
      Специалисты отвечают на вопросы и принимают идеи для
      улучшений с понедельника по пятницу с 10:00 до 18:00 по
      Москве. Пишите:
      <ul>
        <li>
          в Телеграм: <a
            href="https://t.me/magvi_bot"
            target="_blank"
          >t.me/magvi_bot</a>
        </li>
        <li>
          в Макс: <a
            href="https://max.ru/id401703725941_bot"
            target="_blank"
          >max.ru/id401703725941_bot</a>
        </li>
        <li>на эл. почту: <a href="mailto:info@magvi.ru">info@magvi.ru</a></li>
      </ul>
    </template>
  </RModal>
</template>
